import React from "react";
import { func } from "prop-types";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Form,
  FormGroup,
  Label,
  Row,
  Col,
  Collapse,
  Card,
  CardBody
} from "reactstrap";
import Switch from "COMPONENTS/CommonComponents/Switch/Switch";

// Strings
import { getMessage } from "CONFIG/i18n";
import { validateUserName, validateString } from "UTILS/regexValidations";
import {USER_ROLES} from "UTILS/Constants";
import modalScrollBar from "../../ModalScrollBar/ModalScrollBar";

import "../Organisations/AddOrganization.less";
import "../../App/App.less";
import "./AdminDashboard.less";

class AddUserModal extends React.Component {
  static propTypes = {
    handleYesClick: func,
    handleNoClick: func
  };
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      role: USER_ROLES.AGENT,
      email: "",
      errorMessage: "",
      useId: false,
      accountId: "",
      password: "",
      confirmPassword: "",
      isOperator: false,
      operatorSkills: this.props.addUserdata.operatorSkills,
    };
  }

  componentDidUpdate(preProps) {
    if (!_.isEqual(preProps.addUserdata.operatorSkills, this.props.addUserdata.operatorSkills)) {
      this.setState({ operatorSkills: this.props.addUserdata.operatorSkills });
    }
  }

  componentWillUnmount() {
    this.disableCreateUserBtn(false);
  }

  isValidData = () => {
    let UserDetail = this.state;

    if(!UserDetail.accountId || !UserDetail.accountId.trim()){
      this.setState({ errorMessage: getMessage("ERR_MSG_EMPTY_ACCOUNT_ID") });
      return false;
    } else {
      if (!validateUserName(UserDetail.accountId) && !this.state.useId) {
        this.setState({ errorMessage: getMessage("INVALID_EMAIL") });
        return false;
      }
    }
    if(!UserDetail.firstName || !UserDetail.firstName.trim()){
      this.setState({ errorMessage: getMessage("INVALID_FIRST_NAME") });
      return false;
    }
    if(!UserDetail.lastName || !UserDetail.lastName.trim()){
      this.setState({ errorMessage: getMessage("INVALID_LAST_NAME") });
      return false;
    }
    if(this.state.useId) {
      if(!UserDetail.password || !UserDetail.password.trim()) {
        this.setState({ errorMessage: getMessage("INVALID_PASSWORD")});
        return false;
      }
      if(!UserDetail.confirmPassword || !UserDetail.confirmPassword.trim()) {
        this.setState({ errorMessage: getMessage("INVALID_PASSWORD")});
        return false;
      }
    }
    
    return true;
  };

  handleAddClick = () => {
    if (!this.isValidData()) {
      this.disableCreateUserBtn(false);
      return;
    }
    this.setState({ errorMessage: "" });

    let data = Object.assign(
      {},
      {
        firstName: this.state.firstName.trim(),
        lastName: this.state.lastName.trim(),
        role: this.state.role.toUpperCase(),
        username: this.state.accountId.trim(),
        language: this.props.language,
        password: this.state.password.trim(),
        confirmPassword: this.state.confirmPassword.trim(),
        useId: this.state.useId,
        isOperator: this.state.isOperator,
        operatorSkills: this.state.operatorSkills,
      }
    );
    
    this.props.handleAddClick(data, message => {
      if(message.resp !== "success") {
        const errorMessage = getMessage(message.error.code, { ...message.error.details });
        this.setState({ errorMessage: errorMessage });
      } else {
        let resetSkills = _.cloneDeep(this.state.operatorSkills);
        resetSkills = resetSkills.map((skill) => {
          skill.isSelected = false;
          return skill;
        });
        this.setState({
          errorMessage: "",
          firstName: "",
          lastName: "",
          role: USER_ROLES.AGENT,
          email: "",
          accountId: "",
          password: "",
          confirmPassword: "",
          useId: false,
          isOperator: false,
          operatorSkills: resetSkills,
        });
      }
      this.disableCreateUserBtn(true);
    });
  };

  handleCancelClick = () => {
    let resetSkills = _.cloneDeep(this.state.operatorSkills);
    resetSkills = resetSkills.map(skill => {
      skill.isSelected = false;
      return skill;
    });
    this.setState({
      errorMessage: "",
      firstName: "",
      lastName: "",
      role: USER_ROLES.AGENT,
      email: "",
      accountId: "",
      password: "",
      confirmPassword: "",
      useId: false,
      isOperator: false,
      operatorSkills: resetSkills,
    });
    this.props.handleCancelClick();
  };

  handleInputChange = (event) => {
    if(event)
    {
      this.disableCreateUserBtn(false);
    }
    this.setState({
      [event.target.name]: event.target.value
    });
    if (event.target.id === 'role') {
      if (event.target.value === USER_ROLES.ADMIN) {
        const resetSkills = this.state.operatorSkills.map((skill) => {
          skill.isSelected = false;
          return skill;
        })
        this.setState({ isOperator: false, operatorSkills: resetSkills });
      }
    }
    if (this.state.errorMessage) {
      this.setState({ errorMessage: "" });
    }
  };

  handleCheckboxChange = (event) => {
    this.disableCreateUserBtn(false);
    this.setState({
      useId: event.target.checked
    });
    if(event && !event.target.checked) {
      this.setState({
        password: "",
        confirmPassword: ""
      });
    }
  };

  handleSwitch = () => {
    if (this.state.role === USER_ROLES.AGENT) {
      this.setState({
        isOperator: !this.state.isOperator,
      })
      this.disableCreateUserBtn(false);
    } else {
      this.setState({
        isOperator: false,
      })
    }
  }

  renderSwitch = (flag) => {
    if (this.state.role === USER_ROLES.AGENT) {
      return (
        <Switch
          switchOn={flag}
          toggleSwitch={this.handleSwitch}
          disabled={false}
        />
      )
    } else {
      return (
        <Switch
          switchOn={false}
          toggleSwitch={this.handleSwitch}
          disabled={true}
        />
      )
    }
  }

  handleSkills = (evt) => {
    const id = evt.target.dataset.id;
    const newSkills = this.state.operatorSkills.map(skill => {
      if (skill.id == id) {
        skill.isSelected = !skill.isSelected;
      }
      return skill;
    });
    this.setState({
      operatorSkills: newSkills
    });
    this.disableCreateUserBtn(false);
  }

  renderSkills = (skills) => {
    if (!skills || skills.length === 0 || this.state.role === USER_ROLES.ADMIN) return null;

    const elem = skills.map((skill) => {
      return (
        <Row key={skill.id}>
          <Col>
            <Input
              type={'checkbox'}
              name={'skills'}
              data-id={skill.id}
              checked={skill.isSelected}
              onChange={this.handleSkills}
            />
            {" "}
            {skill.name}
          </Col>
        </Row>
      )
    });

    return elem;
  }

  renderButtons = () => {
    return (
      <div className="permissionButtons">
        <Button
          className="buttons borderBtn bgwhite"
          onClick={this.handleCancelClick}
        >
          {getMessage("CANCEL")}
        </Button>{" "}
        <Button 
          id = "createUserBtn"
          onClick={() => {
            this.disableCreateUserBtn(true);
            this.handleAddClick();
          } 
          }
          className="buttons customBtn whiteOnClick">
          {getMessage("CREATE")}
        </Button>
      </div>
    );
  };

  disableCreateUserBtn = (value) =>{
    let createBtn = document.getElementById("createUserBtn");
    if(createBtn){
      createBtn.disabled = value;
      if(value)
        createBtn.classList.add("pointerEventsNone");
      else
        createBtn.classList.remove("pointerEventsNone");
    }
  }

  render() {
    return (
      <Modal
        isOpen={this.props.show}
        className="addOrganisationModal userAddModal passwordChangeModal modalMainDiv modal-width-50"
        toggle={this.handleCancelClick}
        onClosed={() => this.setState({
          errorMessage: ""
        })}
        backdrop="static"
      >
        <ModalHeader className="popupHeader">
          {getMessage("ADD_USER")}
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label className="label modal-label mb-5">{getMessage("TYPE_OF_USER")}</Label>
              <Input
                type="select"
                name="role"
                id="role"
                className="inputFormControl"
                onChange={this.handleInputChange}
                defaultValue={USER_ROLES.AGENT}
              >
                <option value={USER_ROLES.AGENT}>{getMessage("ROLE_AGENT")}</option>
                <option value={USER_ROLES.ADMIN}>{getMessage("ROLE_ADMIN")}</option>
              </Input>
            </FormGroup> 
            <FormGroup>
              <Label className="label modal-label">{getMessage("ACCOUNT_ID")}</Label>
              <Input
                placeholder={getMessage("EMAIL_OR_USER_ID")}
                type="text"
                name="accountId"
                id="accountId"
                onChange={this.handleInputChange}
                className="inputFormControl"
                maxLength="50"
              />
            </FormGroup>
            <Col>
              <Label className="label noPadding">
                <Input
                  type="checkbox"
                  name="useId"
                  onChange={this.handleCheckboxChange}
                  checked={this.state.useId}
                />
                {getMessage("USE_ID")}
              </Label>
            </Col>
            <Collapse isOpen={this.state.useId}>
              <FormGroup>
                <Label className="label modal-label">{getMessage("SET_PASSWORD_TITLE")}</Label>
                <Input
                  type="password"
                  name="password"
                  onChange={this.handleInputChange}
                  className="inputFormControl"
                  value={this.state.password}
                />
              </FormGroup>
              <FormGroup>
                <Label className="label modal-label">{getMessage("SET_CONFIRM_PASSWORD")}</Label>
                <Input
                  type="password"
                  name="confirmPassword"
                  onChange={this.handleInputChange}
                  className="inputFormControl"
                  value={this.state.confirmPassword}
                />
              </FormGroup>
            </Collapse> 
            <FormGroup>
              <Label className="label modal-label">{getMessage("LAST_NAME")}</Label>
              <Input
                type="text"
                name="lastName"
                onChange={this.handleInputChange}
                className="inputFormControl"
                maxLength="50"
              />
            </FormGroup>
            <FormGroup>
              <Label className="label modal-label">{getMessage("FIRST_NAME")}</Label>
              <Input
                type="text"
                name="firstName"
                onChange={this.handleInputChange}
                className="inputFormControl"
                maxLength="50"
              />
            </FormGroup>
            {
              (this.props.isSupportCenter) ? (
                <FormGroup>
                  <Col xs={4} className="d-flex noPadding modal-label">
                    <Label className="label modal-label">{getMessage("OPERATOR")}</Label>
                    {this.renderSwitch(this.state.isOperator)}
                  </Col>
                </FormGroup>
              ) : null
            }
            {
              (this.props.isSupportCenter && this.state.isOperator && this.state.operatorSkills.length > 0)
                ? (
                  <FormGroup>
                    <Col xs={4} className="d-flex noPadding modal-label">
                      <Label className="label modal-label">{getMessage("SKILLS")}</Label>
                    </Col>
                    <Col className="d-flex flex-column">
                      {this.renderSkills(this.state.operatorSkills)}
                    </Col>
                  </FormGroup>
                ) : null
            }
            <div className="errors">{this.state.errorMessage}</div>
          </Form>
        </ModalBody>
        <ModalFooter className="permissionButtons">
          {this.renderButtons()}
        </ModalFooter>
      </Modal>
    );
  }
}

export default modalScrollBar(AddUserModal);
